// src/components/ProductDetails.js
import React from 'react';
import { FaAndroid, FaMicrochip, FaMemory, FaBatteryFull, FaMobileAlt, FaBarcode, FaWifi, FaCamera, FaMapMarkerAlt } from 'react-icons/fa';
import { GiMicrochip } from 'react-icons/gi';
import { MdNfc } from 'react-icons/md';
import './ProductDetails.css';
import Mainmastet from '../masterpage/Mainmastet';
import C72 from '../resorcesfiles/ideak/c72.jpg'


const ProductDetails = () => {
  return (
    <Mainmastet  content={<>
    
    <div className="product-details-container">
    
      <h1>Industry-leading RFID Performance</h1>
      <div className="product-content">
        
        <div className="product-details">
          <div className="features">
            <div className="feature-item">
              <FaAndroid size={32} />
              <p>Android 11/13</p>
            </div>
            <div className="feature-item">
              <FaMicrochip size={32} />
              <p>Octa-core 2.0GHz</p>
            </div>
            <div className="feature-item">
              <FaMemory size={32} />
              <p>RAM+ROM: 3+32GB/4+64GB (Optional)</p>
            </div>
            <div className="feature-item">
              <FaMobileAlt size={32} />
              <p>5.2" IPS 1080P Screen</p>
            </div>
            <div className="feature-item">
              <FaBatteryFull size={32} />
              <p>8000mAh Powerful Battery</p>
            </div>
          </div>
        </div>

        <div className="product-image-container">
          <img src={C72} alt="RFID Reader" className="product-image" />
        </div>
      </div>
      <div className="functions-container">
        <h2>Functions</h2>
        <div className="functions">
          <div className="function-item">
            <GiMicrochip size={32} />
            <p>UHF RFID (Impinj E710/R2000 Chip)</p>
          </div>
          <div className="function-item">
            <FaBarcode size={32} />
            <p>Barcode Scanning (Optional)</p>
          </div>
          <div className="function-item">
            <MdNfc size={32} />
            <p>NFC (Optional)</p>
          </div>
          <div className="function-item">
            <FaCamera size={32} />
            <p>13MP Autofocus Camera</p>
          </div>
          <div className="function-item">
            <FaMapMarkerAlt size={32} />
            <p>Accurate GPS</p>
          </div>
          <div className="function-item">
            <FaWifi size={32} />
            <p>Dual-band WIFI</p>
          </div>
        </div>
      </div>
    </div>
    
    </>} />
  );
};

export default ProductDetails;
